<template>
  <div>
    <v-app-bar id="core-app-bar" absolute v-if="isAuthenticated" :class="{'grey lighten-3' : !isMobileSize, 'primary' : isMobileSize}" app flat height="75">
      <v-toolbar-title class="font-weight-bold align-self-center" :class="{'white--text': isMobileSize, 'primary--text font-weight' : !isMobileSize}">
        <v-btn v-if="isMobileSize" dark icon @click.stop="onClick">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-row align="center" class="mx-0">
          <v-btn icon to="/">
            <v-icon :color="isMobileSize ? 'white' : 'primary'">mdi-view-dashboard</v-icon>
          </v-btn>
          <avatar-menu />
          <!-- <v-btn to="/profile" icon>
            <v-icon color="white">mdi-account</v-icon>
          </v-btn> -->
        </v-row>
      </v-toolbar-items>
    </v-app-bar>
    <v-app-bar id="core-app-bar-login" absolute v-else app elevation-14 color="primary" flat height="100">
      <v-toolbar-title class="white--text font-weight-light align-self-center">
        <v-img @click="clickOnLogo()" :src="logo" :height="70" contain class="img-logo" />
      </v-toolbar-title>            
    </v-app-bar>
  </div>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";
import AvatarMenu from '../shared/AvatarMenu';

export default {
  components: {
    AvatarMenu
  },
  data: () => ({
    notifications: ["New Order", "You have 2 more orders"],
    title: null,
    logo: require("@/assets/logo.png"),
    //responsive: false
  }),

  watch: {
    $route(val) {      
      this.title = val.meta.title;
    }
  },
  computed: {
    ...mapState("auth", ["logged"]),
    ...mapState("app", ["color"])
  },  
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClick() {
      this.setDrawer(!this.$store.state.app.drawer);
    },    
  }
};
</script>

<style>
/* Fix coming in v2.0.8 */
#core-app-bar {
  width: auto;
  border-bottom: 1px solid #DDDDDD !important;
  border-color: #DDDDDD !important;
}

#core-app-bar a {
  text-decoration: none;
}

#core-app-bar .v-toolbar__title {
  font-size: 18px;
}

</style>
